export default __webpack_public_path__ + "static/laravel-b992ed33832932c703ed1c09e7ce7ada.png";